<template>
  <div id="app">
    <Header @routeClick="handleRouteClick" />
    <div :class="{ content: !['TermsOfUse', 'PrivacyPolicy'].includes($route.name) }">
      <b-container>
        <router-view :key="$route.path"/>
      </b-container>
    </div>
    <Footer :i18n="$i18n" @change-locales="changeLocales" @routeClick="handleRouteClick"/>
  </div>
</template>

<script>
import { Header, Footer } from '@/components/ui'

export default {
  name: 'App',
  methods: {
    changeLocales (lang) {
      this.$i18n.locale = lang
      setTimeout(() => {
        window.scrollTo(0, 0)
      }, 1)
    },

    handleRouteClick (to) {
      // if clicking on a link that is the same as current route
      // scroll to the top of the page
      if (to.name === this.$route.name) {
        window.scrollTo(0, 0)
      }
    }
  },
  components: { Header, Footer },
  data () {
    return {
      media: {}
    }
  },
  metaInfo () {
    let tags = [
      { 'http-equiv': 'cache-control', content: 'no-cache, no-store, must-revalidate' },
      { 'http-equiv': 'pragma', content: 'no-cache' },
      { 'http-equiv': 'expires', content: 'Tue, 01 Jan 1980 1:00:00 GMT' },
      { name: 'facebook-domain-verification', content: 'jzb5xhc2vsu8rxtm9z899mm3qyq08n' },
      { name: 'google-site-verification', content: 'eu1aYj825XqCMH-ZO4VZpL9_i4ITerJZP7vA5xOMNuc' },
      { name: 'msapplication-TileColor', content: '#ffffff' },
      { name: 'theme-color', content: '#ffffff' },
      { 'itemprop': 'accessibilityControl', content: 'fullKeyboardControl' },
      { 'itemprop': 'accessibilityControl', content: 'fullMouseControl' },
      { 'itemprop': 'accessibilityHazard', content: 'noFlashingHazard' },
      { 'itemprop': 'accessibilityHazard', content: 'noMotionSimulationHazard' },
      { 'itemprop': 'accessibilityHazard', content: 'noSoundHazard' },
      { 'itemprop': 'accessibilityAPI', content: 'ARIA' },
      { property: 'og:url', content: 'https://www.hrdownloads.com' },
      { property: 'og:type', content: 'website' },
      { property: 'og:locale', content: 'en_CA' },
      { property: 'og:name', content: 'HRdownloads' },
      { property: 'og:site_name', content: 'hrdownloads' },
      { property: 'og:image', content: 'https://www.hrdownloads.com/open-graph/og-image.jpg' },
      { property: 'og:image:height', content: '733' },
      { property: 'og:image:width', content: '1400' },
      { name: 'twitter:card', content: 'summary_large_image' },
      { name: 'twitter:site', content: '@hrdownloadsinc' },
      { name: 'twitter:image', content: 'https://www.hrdownloads.com/open-graph/og-image-twitter.jpg' },
      { name: 'twitter:image-alt', content: 'Real People. Complete Support' },
      { name: 'twitter:images0', content: 'https://www.hrdownloads.com/open-graph/og-image2.jpg' }
    ]

    const detailPages = ['BlogPost', 'MediaPost']
    if (!detailPages.includes(this.$route.name) && this.media) {
      tags.push({ name: 'description', content: this.media.metaDescription })
      tags.push({ name: 'twitter:title', content: this.media.metaTitle })
      tags.push({ name: 'twitter:description', content: this.media.metaDescription })
      tags.push({ property: 'og:title', content: this.media.metaTitle })
      tags.push({ property: 'og:description', content: this.media.metaDescription })
    }

    return {
      title: this.media.metaTitle,
      meta: tags
    }
  },
  mounted () {
    setMedia(this)
  },
  watch: {
    $route () {
      setMedia(this)
    }
  }
}

function setMedia (app) {
  const detailPages = ['BlogPost', 'MediaPost']
  const defaultMedia = app.media = {
    'metaTitle': 'HRdownloads® | Canadian HR software with content',
    'metaDescription': 'Get unlimited access to Canadian HR policies, legislative updates, employee training modules, and advice. Our software supports your everyday HR tasks, so you can focus on what you do best.'
  }

  if (detailPages.includes(app.$route.name)) {
    return
  }

  let routeOptions = app.$router.options.routes.find(route => route.name === app.$route.matched[0].name)

  if (app.$route.matched.length > 1) {
    routeOptions = routeOptions.children.find(route => route.name === app.$route.matched[1].name)
  }

  const seoPage = routeOptions.seo || routeOptions.path.replace('/', '')
  app.axios.get(`${process.env['CMS_DOMAIN']}/api/seo/pages/${seoPage}`)
    .then(data => {
      app.media = data.data || defaultMedia
    })
    .catch(err => {
      console.log(err)
      app.media = defaultMedia
    })
}
</script>

<style lang="sass">
#app
  display: grid
  grid-template-rows: auto 1fr auto
  min-height: 100vh
  position: relative

.content
  width: 100%
  max-width: 100%
  overflow: hidden
</style>



// WEBPACK FOOTER //
// src/App.vue